module.exports = __webpack_public_path__ + "img/laptop.829bdc27.png";